export default function Footer() {
  return (
    <footer className="bg-background-200/70">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-md">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <span className="font-[number] text-base leading-none">69</span>
              </span>
              <span className="text-base font-bold text-foreground-950">69黑料</span>
            </a>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              争议人物与翻车名单的公开信息盘点，帮助你在信息洪流里快速对上一页「谁正在风口浪尖」。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <div className="text-xs font-semibold tracking-wide text-foreground-800">栏目</div>
              <div className="mt-3 flex flex-col gap-2">
                {[
                  ["人物档案", "#profiles"],
                  ["翻车榜单", "#ranking"],
                  ["塌房时间线", "#timeline"],
                ].map(([label, href]) => (
                  <a key={label} href={href} className="w-fit text-sm text-foreground-500 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer">
                    {label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold tracking-wide text-foreground-800">盘点</div>
              <div className="mt-3 flex flex-col gap-2">
                {[
                  ["人物话题墙", "#topics"],
                  ["热词归档", "#topics"],
                  ["评论区现场", "#comments"],
                ].map(([label, href]) => (
                  <a key={label} href={href} className="w-fit text-sm text-foreground-500 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer">
                    {label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold tracking-wide text-foreground-800">关注</div>
              <div className="mt-3 flex flex-col gap-2">
                <span className="flex items-center gap-2 text-sm text-foreground-500 whitespace-nowrap">
                  <i className="ri-fire-line text-primary-500" /> 讨论热度榜
                </span>
                <span className="flex items-center gap-2 text-sm text-foreground-500 whitespace-nowrap">
                  <i className="ri-article-line text-secondary-500" /> 周更复盘
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-2 text-xs text-foreground-500">
            <span className="text-foreground-400">© 2026 69黑料 · 争议人物与翻车名单公开信息盘点</span>
            <p className="max-w-2xl leading-5">
              本站内容均为对已公开信息的客观整理，供资讯参考与舆论观察使用，不构成对任何个人的事实认定或评价结论。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-400">
            <i className="ri-shield-check-line text-secondary-500" />
            双信源复核 · 动态更新
          </span>
        </div>
      </div>
    </footer>
  );
}